module.exports = __webpack_public_path__ + "static/img/carousel_1_quelbo_ar_4_3_w_1534.0f8849a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_1_quelbo_ar_4_3_w_1534.jpg
// module id = KrWF
// module chunks = 0